import { SignalingMessageCandidate } from "../../../services";
import { BaseStreamingCommand } from "./BaseStreamingCommand";

export class IceCandidateCommand extends BaseStreamingCommand {
  public execute(e: unknown): void {
    const event = e as CustomEvent<SignalingMessageCandidate>;
    const candidate = event.detail;
    if (!this.checkRoomId(candidate.data.room)) return;
    if (!candidate.from) return;
    const peer = this.getPeer(candidate.from);
    if (!peer) return;
    let iceCandidate: RTCIceCandidate;
    try {
      iceCandidate = new RTCIceCandidate({
        sdpMLineIndex: candidate.data.sdpMLineIndex,
        sdpMid: candidate.data.sdpMid,
        candidate: candidate.data.candidate
      });
    } catch (error) {
      console.warn("Failed to build ICE candidate", error);
      return;
    }
    peer.handleCandidate(iceCandidate).catch((error: unknown) => {
      console.warn("Failed to apply ICE candidate", error);
    });
  }
}
